<template>
    <div>
        <b-row>
            <b-col sm="2" md="4" v-if="fornecedores">
                <b-form-group>
                    <label>Fornecedor</label>
                    <b-form-select
                        :plain="true"
                        :options="fornecedores"
                        text-field="nome"
                        value-field="codFornecedor"
                        v-model="fornecedor"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="2" md="2">
                <b-form-group>
                    <label>Calcular Realizado Por</label>
                    <b-form-select
                        :plain="true"
                        :options="saldoPorOptions"
                        text-field="descricao"
                        value-field="codigo"
                        v-model="saldoPor"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="2" md="2">
                <b-form-group>
                    <label>Natureza do Contrato</label>
                    <b-form-select
                        :plain="true"
                        :options="naturezaContratoOptions"
                        v-model="naturezaContrato"
                        text-field="descricao"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="2" md="2">
                <b-form-group>
                    <label>Ordenar Por (Mês atual)</label>
                    <b-form-select
                        :plain="true"
                        :options="ordenarPorOptions"
                        v-model="ordenarPor"
                        text-field="descricao"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col class="mt-4">
                <b-button variant="primary" @click="$emit('pesquisar')"
                    >Pesquisar
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        fornecedores: {
            type: Array
        },
    },

    data() {
        return {
            fornecedor: null,
            saldoPorOptions: [
                {
                    codigo: 0,
                    descricao: 'CONTRATO'
                },
                {
                    codigo: 1,
                    descricao: 'FASE DEMANDA'
                }
            ],
            saldoPor: 0,
            naturezaContratoOptions: [
                {
                    codigo: '0',
                    descricao: "VENDA"
                },
                {
                    codigo: '1',
                    descricao: "COMPRA"
                },
                // {
                    // codigo: '2',
                    // descricao: "Ambos"
                // },
                {
                    codigo: null,
                    descricao: 'TODAS'
                }
            ],
            naturezaContrato: null,
            ordenarPorOptions: [
                {
                    codigo: 0,
                    descricao: 'POSITIVAS PRIMEIRO'
                },
                {
                    codigo: 1,
                    descricao: 'NEGATIVAS PRIMEIRO'
                },
                {
                    codigo: 2,
                    descricao: 'CODIGO DO CONTRATO'
                },
            ],
            ordenarPor: 0
        }
    },

    computed: {
        filtro() {
            let retorno = {
                fornecedor: this.fornecedor,
                saldoPor: this.saldoPor,
                naturezaContrato: this.naturezaContrato,
                ordenarPor: this.ordenarPor
            }
            return retorno
        },
    },

    watch: {
        fornecedor() {
            this.$emit('filtroAtualizado', this.filtro)
        },
        saldoPor() {
            this.$emit('filtroAtualizado', this.filtro)
        },
        naturezaContrato() {
            this.$emit('filtroAtualizado', this.filtro)
        },
        ordenarPor() {
            this.$emit('filtroAtualizado', this.filtro)
        },
    }
}
</script>
